import { render, staticRenderFns } from "./RegistrationRequestCommonInfoEdit.vue?vue&type=template&id=e18561bc&scoped=true"
import script from "./RegistrationRequestCommonInfoEdit.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestCommonInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18561bc",
  null
  
)

export default component.exports